import { render, staticRenderFns } from "./CowsRegistrationMainPage.vue?vue&type=template&id=10b5dbec&scoped=true&"
import script from "./CowsRegistrationMainPage.vue?vue&type=script&lang=js&"
export * from "./CowsRegistrationMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5dbec",
  null
  
)

export default component.exports